<template>
  <div class="scoket" style="position: fixed; right: 0px; bottom: 0px; height: 200px; width: 400px; z-index: 9999; background: rgba(21, 42, 66, 0.81);">
    <iframe style="position: fixed; right: 0px; bottom: 0px; height: 200px; width: 400px; z-index: -1; border:none;"></iframe>
    <div class="title"></div>
    <div class="content" v-if="time > 0">
      {{ $t('base.message.sockettime', {taskName: taskName, time: time})}}
    </div>
    <div class="content" v-else>
      {{ $t('base.message.socketnow', {taskName: taskName})}}
    </div>
    <div class="operator">
      <el-button @click="closed">{{ $t('base.button.close') }}</el-button>
      <el-button type="warning" @click="start">{{ $t('base.button.start') }}</el-button>
    </div>
  </div>
</template>

<script>
  import { Cache } from "$utils";
  export default {
    name: "app-scoket-dialog",
    data() {
      return {
        taskId:"",
        taskName:"",
        time:5
      }
    },
    created(){
      this.setWebsocketData();
    },
    methods:{
      start(){
        this.$parent.appScoketDialogIsShow = false
          if(this.$route.path === "/videoPatrol/task") {
              this.$router.push({path:'/videoPatrol/task',query: {taskCode:this.taskId}})
              window.location.reload()
          }else{
            this.$router.push({path:'/videoPatrol/task',query: {taskCode:this.taskId}})
          }
      },
      setWebsocketData(){
        const data = Cache.get("videoPatrol-autoStart");
        this.taskName = data.taskName;
        this.taskId = data.taskCode;
        this.time = data.time;
      },
      closed(){
        this.$parent.appScoketDialogIsShow = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .scoket{
    text-align: center;
    font-size: 16px;
    vertical-align: middle;
    padding-top: 50px;
    .content{
      width:80%;
      margin: 0 auto;
      text-align: left;
    }
    .operator{
      padding-top: 20px;
      box-sizing: border-box;
    }
  }
</style>
